import { formatIndianNumber } from "./format";

export interface ReportColumn<T = any> {
  header: string;
  value: (row: T) => string | number;
}

/**
 * Export a report to CSV. The file carries a header block — report name, the
 * filters applied and the generation date/time — so the export stays
 * identifiable weeks later, exactly as financial software requires.
 */
export function exportReportCSV<T = any>(opts: {
  filename: string;
  reportName: string;
  filters: string[];
  columns: ReportColumn<T>[];
  rows: T[];
}): void {
  const escape = (s: string) => `"${s.replace(/"/g, '""')}"`;
  const lines: string[] = [];
  lines.push(escape(opts.reportName));
  lines.push(escape(`Filters: ${opts.filters.length ? opts.filters.join(" | ") : "None"}`));
  lines.push(escape(`Generated: ${new Date().toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}`));
  lines.push("");
  lines.push(opts.columns.map((c) => escape(c.header)).join(","));
  for (const row of opts.rows) {
    lines.push(opts.columns.map((c) => escape(String(c.value(row) ?? ""))).join(","));
  }
  const blob = new Blob(["\ufeff" + lines.join("\n")], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${opts.filename}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

/** Compact Indian-grouped number without symbol, for CSV cells. */
export function csvAmount(value: number): string {
  return formatIndianNumber(value);
}